/**
 * 10.7P — Formatação de NÚMEROS GRANDES (dano/vida chegam a milhões).
 * 999 → "999" · 12 400 → "12.4K" · 1 800 000 → "1.8M" · 3.2e9 → "3.2B" · trilhões → "T".
 * Mantém 1 casa decimal só quando ajuda a distinguir (e sem ".0" pendurado).
 */
const UNITS = ["", "K", "M", "B", "T", "Qa", "Qi"];

export function fmtNum(n: number): string {
  if (!Number.isFinite(n)) return "0";
  const neg = n < 0;
  let v = Math.abs(n);
  if (v < 1000) return (neg ? "-" : "") + Math.round(v).toString();
  let u = 0;
  while (v >= 1000 && u < UNITS.length - 1) { v /= 1000; u++; }
  // 1 casa quando < 100 (12.4K), inteiro quando >= 100 (128K) — mais limpo
  const s = v < 100 ? v.toFixed(1).replace(/\.0$/, "") : Math.round(v).toString();
  return (neg ? "-" : "") + s + UNITS[u];
}

/** 10.9BU — duração legível: "15h", "2h 30min", "45min", "50s". */
export function fmtDuration(ms: number): string {
  const s = Math.max(0, Math.ceil(ms / 1000));
  const h = Math.floor(s / 3600), m = Math.floor((s % 3600) / 60);
  if (h > 0) return m > 0 ? `${h}h ${m}min` : `${h}h`;
  if (m > 0) return `${m}min`;
  return `${s}s`;
}
